"use client";

import clsx from "clsx";
import React from "react";
import { ControllerFieldState } from "react-hook-form";
import { FormControl, FormItem, FormLabel, FormMessage } from "components/ui/form";
import { Input } from "components/ui/input";
type TextFieldProps = {
  field: any;
  fieldState: ControllerFieldState;
  label: string;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const TextFieldInput = React.forwardRef(
  (
    { field, fieldState, label, className, inputClassName, ...rest }: TextFieldProps,
    ref: React.Ref<HTMLInputElement>
  ) => {
    return (
      <FormItem className={clsx("relative", className)}>
        <FormControl>
          <Input
            type=""
            ref={ref}
            {...field}
            className={clsx(
              "!focus-visible:outline-none border border-primary-700 outline-none focus:border-transparent focus:!ring-2 focus:ring-primary-700 disabled:border-neutral-200",
              "peer h-16 w-full px-4 py-4 pb-2 pt-6 font-matter max-sm:text-md",
              "rounded-lg bg-white text-base text-base-primary dark:bg-baseinverse-dark-primary  ",
              "min-h-[58px] disabled:cursor-not-allowed disabled:bg-neutral-200 disabled:text-base-disabled disabled:ring-neutral-200",
              inputClassName,
              { "ring-2 ring-red-700 focus:ring-red-700": fieldState.error }
            )}
            {...rest}
            placeholder={rest.placeholder || " "}
          />
        </FormControl>
        <FormLabel
          className={clsx(
            "absolute left-4 top-2 font-matter ",
            "pointer-events-none cursor-text text-[14px]  transition-all",
            "font-matter text-gray-500",
            "transition-all duration-300 peer-focus:top-2 peer-focus:text-xs peer-focus:text-base-primary ",
            !rest.placeholder && "peer-placeholder-shown:top-5 peer-placeholder-shown:text-[16px]"
          )}
        >
          {label}
        </FormLabel>
        <FormMessage className="mb-1.5 mt-2 block text-base font-medium" />
      </FormItem>
    );
  }
);

TextFieldInput.displayName = "TextFieldinput";
export default TextFieldInput;
